<div class="modal-dialog ">
  <div class="modal-content">
    <div class="modal-header">Restore files</div>

    <div class="modal-body">
      <p class="mb-3">You are about to restore the following files and remove their delete marker</p>
      <div class="files-table-scroll">
        <table class="cl-table-data cl-table-data-light">
          <thead>
          <tr>
            <th class="cl-table-head cl-p-tiny ">

            </th>
            <th class="cl-table-head cl-p-tiny ">
              File or folder name
            </th>
            <th class="cl-table-head cl-p-tiny ">
              Last Modified
            </th>
          </tr>
          </thead>
          <tbody>
            @for (file of files; track file) {
              <tr>
                <td style="width: 40px">
                  <i class="fas fa-file"></i>

                </td>
                <td>
                  {{file.name}}
                </td>
                <td>
                  {{file.last_modified | cldate }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

    </div>
    <div class="modal-footer">
        <span class="modal-footer-left cl-spacing-box cl-spacing-none">
          <button type="button" class="btn cl-color-secondary it-cancel"
                  (click)="dialogRef.close()"><span>Cancel</span>
          </button></span>
      <span class="modal-footer-center cl-spacing-box cl-spacing-none"></span>
      <span class="modal-footer-right cl-spacing-box cl-spacing-none">
            <button type="button" class="btn cl-color-primary it-ok" [class.cl-btn-spinner]="deleting"
                    (click)="performUndelete()"
                    [disabled]="deleting"
            >
              <span>Restore</span>
            </button></span>
    </div>
  </div>
</div>
